import { Accordion, accordionBlockTypename } from './Accordion/index.jsx'
import { AlertBannerBlock, alertBannerBlockTypename } from './AlertBannerBlock/index.jsx'
import { ArchiveBlock, archiveBlockTypename } from './ArchiveBlock/index.jsx'
import { BentoBlock } from './Bento/index.jsx'
import { Calculator, calculatorTypename } from './Calculator/index.jsx'
import { CalloutBlock } from './CalloutBlock/index.jsx'
import { CallToActionBlock, callToActionBlockTypename } from './CallToAction/index.jsx'
import { CarouselBlock } from './Carousel/index.jsx'
import { ContentBlock, contentBlockTypename } from './Content/index.jsx'
import { CrossLinks, crossLinksBlockTypename } from './CrossLinks/index.jsx'
import { DevicePreview, devicePreviewBlockTypename } from './DevicePreview/index.jsx'
import { Disclaimers } from './Disclaimers/index.jsx'
import { DownloadBanner } from './DownloadBanner/index.jsx'
import { FormBlock } from './DynamicForm/index.jsx'
import { FeatureGridBlock } from './FeatureGrid/index.jsx'
import { FeatureSection } from './FeatureSection/index.jsx'
import { ImageBlock, imageBlockTypename } from './ImageBlock/index.jsx'
import { LegalBlock } from './LegalBlock/index.jsx'
import { OfferBlock, offerBlockTypename } from './OfferBlock/index.jsx'
import { PriceTierBlock, priceTierBlockTypename } from './PriceTier/index.jsx'
import { ProsCons, prosConsTypename } from './ProsConsBlock/index.jsx'
import { quoteBlockTypename, Quotes } from './Quotes/index.jsx'
import { Resources } from './Resources/index.jsx'
import { RichTextBlock, richTextBlockTypename } from './RichTextBlock/index.jsx'
import { RichTextSection, richTextSectionBlockTypename } from './RichTextSection/index.jsx'
import { TableBlock, tableBlockTypename } from './TableBlock/index.jsx'
import { VideoBlock, videoBlockTypename } from './VideoBlock/index.jsx'
import { VideoEmbedBlock, videoEmbedTypename } from './VideoEmbedBlock/index.jsx'

export const baseBlockComponents = {
  [calculatorTypename]: Calculator,
  [callToActionBlockTypename]: CallToActionBlock,
  [devicePreviewBlockTypename]: DevicePreview,
  [contentBlockTypename]: ContentBlock,
  [archiveBlockTypename]: ArchiveBlock,
  [quoteBlockTypename]: Quotes,
  [crossLinksBlockTypename]: CrossLinks,
  [accordionBlockTypename]: Accordion,
  CmsFeatureSection: FeatureSection,
  CmsCarousel: CarouselBlock,
  CmsBento: BentoBlock,
  [priceTierBlockTypename]: PriceTierBlock,
  CmsFormBlock: FormBlock,
  CmsResources: Resources,
  CmsFeatureGrid: FeatureGridBlock,
  CmsDisclaimers: Disclaimers,
  CmsLegalBlock: LegalBlock,
  [videoBlockTypename]: VideoBlock,
  [richTextSectionBlockTypename]: RichTextSection,
  [offerBlockTypename]: OfferBlock,
  [tableBlockTypename]: TableBlock,
  [imageBlockTypename]: ImageBlock,
  CmsDownloadBanner: DownloadBanner,
  CmsCalloutBlock: CalloutBlock,
  [prosConsTypename]: ProsCons,
  [videoEmbedTypename]: VideoEmbedBlock,
  [richTextBlockTypename]: RichTextBlock,
  [alertBannerBlockTypename]: AlertBannerBlock,
} as const
